/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcknowledgeProjectClientItemRequest
 */
export interface AcknowledgeProjectClientItemRequest {
    /**
     * 
     * @type {string}
     * @memberof AcknowledgeProjectClientItemRequest
     */
    type: AcknowledgeProjectClientItemRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AcknowledgeProjectClientItemRequest
     */
    comment?: string;
}


/**
 * @export
 */
export const AcknowledgeProjectClientItemRequestTypeEnum = {
    ProjectRenewalDismissed: 'PROJECT_RENEWAL_DISMISSED',
    LetAppraisalRedirect: 'LET_APPRAISAL_REDIRECT'
} as const;
export type AcknowledgeProjectClientItemRequestTypeEnum = typeof AcknowledgeProjectClientItemRequestTypeEnum[keyof typeof AcknowledgeProjectClientItemRequestTypeEnum];


/**
 * Check if a given object implements the AcknowledgeProjectClientItemRequest interface.
 */
export function instanceOfAcknowledgeProjectClientItemRequest(value: object): value is AcknowledgeProjectClientItemRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AcknowledgeProjectClientItemRequestFromJSON(json: any): AcknowledgeProjectClientItemRequest {
    return AcknowledgeProjectClientItemRequestFromJSONTyped(json, false);
}

export function AcknowledgeProjectClientItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcknowledgeProjectClientItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function AcknowledgeProjectClientItemRequestToJSON(value?: AcknowledgeProjectClientItemRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'comment': value['comment'],
    };
}

